import './full-width-image.scss';

/**
 * version    1.0
 * class      <type> (FullWidthImage)
 * classdesc  Component that manage the full-width-image section
 */
export class FullWidthImage {}
